// extracted by mini-css-extract-plugin
export var breadCrumbIcon = "k_S";
export var breadcrumbElement = "k_N";
export var heroMargins = "k_R";
export var listBreadcrumb = "k_Q";
export var listBreadcrumbModeDark = "k_P";
export var listBreadcrumbModeLight = "k_M";